{
  "auth": {
    "agree": "Я согласен с",
    "createAccount": "Создать аккаунт",
    "createNewAccount": "Создать новый аккаунт",
    "email": "Электронная почта",
    "login": "Войти",
    "password": "Пароль",
    "recover_password": "Восстановить пароль",
    "sign_up": "Зарегистрироваться",
    "keep_logged_in": "Оставаться в системе",
    "termsOfUse": "Условиями использования.",
    "reset_password": "Сбросить пароль"
  },
  "404": {
    "title": "Этой страницы не существует.",
    "text": "Если вы считаете, что это ошибка, напишите нам на ",
    "back_button": "Вернуться в панель управления"
  },
  "typography": {
    "primary": "Основные стили текста",
    "secondary": "Дополнительные стили текста"
  },
  "dashboard": {
    "versions": "Версии",
    "setupRemoteConnections": "Настроить удалённые подключения",
    "currentVisitors": "Текущие посетители",
    "navigationLayout": "расположение навигации",
    "topBarButton": "Верхняя панель",
    "sideBarButton": "Боковая панель"
  },
  "language": {
    "brazilian_portuguese": "Португальский",
    "english": "Английский",
    "spanish": "Испанский",
    "simplified_chinese": "Китайский (упрощённый)",
    "persian": "Персидский"
  },
  "menu": {
    "auth": "Авторизация",
    "employee": "Наша команда",
    "buttons": "Кнопки",
    "timelines": "Таймлайны",
    "dashboard": "Информация",
    "billing": "Биллинг",
    "login": "Вход",
    "preferences": "Аккаунт",
    "payments": "Платежи",
    "settings": "Общие настройки",
    "pricing-plans": "Тарифные планы",
    "payment-methods": "Способы оплаты",
    "signup": "Регистрация",
    "recover-password": "Восстановление пароля",
    "recover-password-email": "Письмо для восстановления пароля",
    "404": "404",
    "faq": "FAQ",
    "users": "Пользователи",
    "projects": "Кейсы",
    "projects_categories": "Категории кейсов",
    "reviews": "Отзывы",
    "clients": "Клиенты",
    "homepage": "Настройки главной",
    "articles": "Статьи",
    "articles_categories": "Категории статей",
    "feedback": "Обратная связь",
    "job": "Присоединиться к команде",
    "skills": "Компетенции",
    "services": "Продукты",
    "docs": {
      "cookies": "Политика cookie",
      "privacy": "Политика конфиденциальности",
      "personal-data": "Политика перс. данных"
    }
  },
  "messages": {
    "all": "Все сообщения",
    "new": "Новые сообщения от {name}",
    "mark_as_read": "Пометить как прочитанное"
  },
  "navbar": {
    "messageUs": "Вопросы по веб-разработке:",
    "repository": "Репозиторий GitHub"
  },
  "notifications": {
    "all": "Все уведомления",
    "less": "Свернуть уведомления",
    "mark_as_read": "Пометить как прочитанное",
    "sentMessage": "отправил вам сообщение",
    "uploadedZip": "загрузил новый Zip-файл с {type}",
    "startedTopic": "создал новую тему"
  },
  "user": {
    "language": "Изменить язык",
    "logout": "Выйти",
    "profile": "Профиль",
    "settings": "Настройки",
    "billing": "Биллинг",
    "faq": "FAQ",
    "helpAndSupport": "Помощь и поддержка",
    "projects": "Проекты",
    "account": "Аккаунт",
    "explore": "Обзор"
  },
  "treeView": {
    "basic": "Базовый",
    "icons": "С иконками",
    "selectable": "Выбираемый",
    "editable": "Редактируемый",
    "advanced": "Продвинутый"
  },
  "chat": {
    "title": "Чат",
    "sendButton": "Отправить"
  },
  "spacingPlayground": {
    "value": "Значение",
    "margin": "Отступ",
    "padding": "Поля"
  },
  "spacing": {
    "title": "Отступы"
  },
  "cards": {
    "cards": "Карточки",
    "fixed": "Фиксированная",
    "floating": "Плавающая",
    "contentText": "Уникальные полосы зебр делают их одними из самых узнаваемых животных.",
    "contentTextLong": "Уникальные полосы зебр делают их одними из самых узнаваемых животных. Они обитают в различных средах: лугах, саваннах, лесах, колючих кустарниках, горах и прибрежных холмах. Различные антропогенные факторы сильно повлияли на популяцию зебр, особенно охота за шкурами и разрушение среды обитания. Зебра Греви и горная зебра находятся под угрозой исчезновения. В то время как равнинные зебры гораздо более многочисленны, один подвид, квагга, вымер.",
    "rowHeight": "Высота строки",
    "title": {
      "default": "По умолчанию",
      "withControls": "С элементами управления",
      "customHeader": "С пользовательским заголовком",
      "withoutHeader": "Без заголовка",
      "withImage": "С изображением",
      "withTitleOnImage": "С заголовком на изображении",
      "withCustomTitleOnImage": "С пользовательским заголовком на изображении",
      "withStripe": "С полосой",
      "withBackground": "С фоном"
    },
    "button": {
      "main": "Основная",
      "cancel": "Отмена",
      "showMore": "Показать больше",
      "readMore": "Читать далее"
    },
    "link": {
      "edit": "Редактировать",
      "setAsDefault": "Установить по умолчанию",
      "delete": "Удалить",
      "traveling": "Путешествия",
      "france": "Франция",
      "review": "Обзор",
      "feedback": "Оставить отзыв",
      "readFull": "Читать полностью",
      "secondaryAction": "Дополнительное действие",
      "action1": "Действие 1",
      "action2": "Действие 2"
    }
  },
  "colors": {
    "themeColors": "Цвета темы",
    "extraColors": "Дополнительные цвета",
    "gradients": {
      "basic": {
        "title": "Градиенты кнопок"
      },
      "hovered": {
        "title": "Градиенты при наведении",
        "text": "Осветление на 15% применено к исходному стилю (градиент или цвет) для состояния наведения."
      },
      "pressed": {
        "title": "Градиенты при нажатии",
        "text": "Затемнение на 15% применено к исходному стилю (градиент или цвет) для состояния нажатия."
      }
    }
  },
  "tabs": {
    "alignment": "Выравнивание вкладок",
    "overflow": "Переполнение вкладок",
    "hidden": "Вкладки со скрытым слайдером",
    "grow": "Растягивающиеся вкладки"
  },
  "helpAndSupport": "Помощь и поддержка",
  "aboutVuesticAdmin": "О Vuestic Admin",
  "supportAndConsulting": "Поддержка и консультации",
  "search": {
    "placeholder": "Поиск..."
  },
  "buttonSelect": {
    "dark": "Тёмная",
    "light": "Светлая"
  },
  "vuestic": {
    "search": "Поиск",
    "noOptions": "Элементы не найдены",
    "ok": "ОК",
    "cancel": "Отмена",
    "uploadFile": "Загрузить файл",
    "undo": "Отменить",
    "dropzone": "Перетащите файлы сюда для загрузки",
    "fileDeleted": "Файл удалён",
    "closeAlert": "закрыть уведомление",
    "backToTop": "наверх",
    "toggleDropdown": "переключить выпадающий список",
    "carousel": "карусель",
    "goPreviousSlide": "предыдущий слайд",
    "goNextSlide": "следующий слайд",
    "goSlide": "перейти к слайду {index}",
    "slideOf": "слайд {index} из {length}",
    "close": "закрыть",
    "openColorPicker": "открыть палитру цветов",
    "colorSelection": "выбор цвета",
    "colorName": "цвет {color}",
    "decreaseCounter": "уменьшить счётчик",
    "increaseCounter": "увеличить счётчик",
    "selectAllRows": "выбрать все строки",
    "sortColumnBy": "сортировать столбец по {name}",
    "selectRowByIndex": "выбрать строку {index}",
    "resetDate": "сбросить дату",
    "nextPeriod": "следующий период",
    "switchView": "переключить вид",
    "previousPeriod": "предыдущий период",
    "removeFile": "удалить файл",
    "reset": "сбросить",
    "pagination": "пагинация",
    "goToTheFirstPage": "перейти на первую страницу",
    "goToPreviousPage": "перейти на предыдущую страницу",
    "goToSpecificPage": "перейти на страницу {page}",
    "goToSpecificPageInput": "введите номер страницы для перехода",
    "goNextPage": "следующая страница",
    "goLastPage": "последняя страница",
    "currentRating": "текущий рейтинг {value} из {max}",
    "voteRating": "оценка {value} из {max}",
    "optionsFilter": "фильтр опций",
    "splitPanels": "разделить панели",
    "movePaginationLeft": "переместить пагинацию влево",
    "movePaginationRight": "переместить пагинацию вправо",
    "resetTime": "сбросить время",
    "closeToast": "закрыть уведомление",
    "selectedOption": "Выбранная опция",
    "noSelectedOption": "Опция не выбрана",
    "breadcrumbs": "хлебные крошки",
    "counterValue": "значение счётчика",
    "selectedDate": "выбранная дата",
    "selectedTime": "выбранное время",
    "progressState": "состояние прогресса",
    "color": "цвет",
    "next": "Далее",
    "back": "Назад",
    "finish": "Завершить",
    "step": "шаг",
    "progress": "прогресс",
    "loading": "Загрузка",
    "sliderValue": "Текущее значение: {value}",
    "switch": "Переключатель",
    "inputField": "Поле ввода",
    "fileTypeIncorrect": "Неправильный тип файла",
    "select": "Выбрать опцию"
  }
}
